<template>
  <div class="d-flex justify-center align-center">
    <v-btn color="red" outlined @click="onDelete">Xóa khách hàng</v-btn>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions({ updateLead: 'lead/updateLead' }),
    onDelete() {
      this.$dialog.confirm({
        title: 'Xác nhận xóa khách hàng',
        text: 'Bọn có chắc là bạn muốn xóa khách hàng này không?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.updateLead({ id: this.$route.params.id, isArchived: 'true' })
            this.$alert.success('Xóa khách hàng thành công')
            this.$router.push('/lead')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
}
</script>